import { Pipe, PipeTransform, Injectable } from '@angular/core';

export interface RiskAddress
{
  id: string;
  slug: string;
  address_type: string;
  level_number?: string | null;
  unit_number?: string | null;
  street_number: string;
  street_name: string;
  unit_type?: string | null;
  level_type?: string | null;
  street_type: string;
  GNAF_ID: number;
  m_block_2016: number;
  get_street_type_display: string;
  get_unit_type_display?: string | null;
  get_level_type_display?: string | null;
  suburb_obj?: null | {
    id: number;
    postcode: number;
    suburb: string;
    state: string;
  };
  suburb: number;
  longitude?: string | null;
  latitude?: string | null;
  street_line?: string | null;
}


@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {
  transform(value: RiskAddress, ...args: unknown[]): string {
    let formattedAddress = 'Address unavailable';

    // handles null / undefined cases
    if (!value) {
      return formattedAddress;
    }

    // formating string from a known address object
      const addressParts: string[] = [];

      // Format Unit (if available)
      if (value.unit_type) {
        if (value.get_unit_type_display) {
          addressParts.push(value.get_unit_type_display);
        }
        if (value.unit_number) {
          addressParts.push(value.unit_number);
        }
      }

      // Format Level (if available)
      if (value.level_type) {
        if (value.get_level_type_display) {
          addressParts.push(value.get_level_type_display);
        }
        if (value.level_number) {
          addressParts.push(value.level_number);
        }
      }

      // Format Street
      if (value.street_line) {
        addressParts.push(`${value.street_line},`);
      } else {
        if (value.street_number) {
          addressParts.push(value.street_number);
        }
        if (value.street_name) {
          addressParts.push(value.street_name);
        }
        if (value.get_street_type_display) {
          addressParts.push(`${value.get_street_type_display},`);
        }
      }

      // Format Suburb
      if (value.suburb_obj) {
        if (value.suburb_obj.suburb) {
          addressParts.push(value.suburb_obj.suburb);
        }
        if (value.suburb_obj.state) {
          addressParts.push(value.suburb_obj.state);
        }
        if (value.suburb_obj.postcode) {
          addressParts.push(`${value.suburb_obj.postcode}`);
        }
      }
      // Clean up and format the final address
      formattedAddress = addressParts
        .join(' ')
        .replace(/,,/g, ',') // Fix double commas
        .replace(/, ,/g, ',') // Fix double commas
        .replace(/\s+/g, ' ') // Fix multiple spaces
        .trim();

      // Remove trailing comma if exists
      if (formattedAddress.endsWith(',')) {
        formattedAddress = formattedAddress.slice(0, -1).trim();
      }

    return formattedAddress;
  }
}
